import { useSessionWorkPanelEvidenceChrome } from '@/hooks/useSessionWorkPanelEvidenceChrome';
import {
  SessionWorkPanelEvidenceChromeProvider,
  type UseSessionWorkPanelEvidenceChrome,
} from '@heidi/agents';
import { type JSX, type ReactNode } from 'react';

const useEvidenceChrome: UseSessionWorkPanelEvidenceChrome = (options) =>
  useSessionWorkPanelEvidenceChrome(options);

/** Layout-scoped. The adapter is one identity and is never conditional. */
export const SessionWorkPanelEvidenceChromeHost = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <SessionWorkPanelEvidenceChromeProvider useChrome={useEvidenceChrome}>
    {children}
  </SessionWorkPanelEvidenceChromeProvider>
);
